import cn from 'classnames'
import { useTranslate } from 'react-polyglot'
import { GlobalTextPreset } from '~/@types/text-preset'

import { useStyle } from '~/providers/StyleProvider'

import { FILTER } from '~/data/dictionary'

type NoResultsProps = {
  className?: string
}

export default function NoResults({ className }: NoResultsProps) {
  const t = useTranslate()
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title24SangBleu,
  })

  return <p className={cn(className, titleStyle)}>{t(FILTER.NO_RESULTS)}</p>
}
